import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconHeadphones.tsx
const OutlinedFilledHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M349-97H189q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97H611v-342h160v-41q0-121.25-84.82-206.13-84.82-84.87-206-84.87T274-686.13Q189-601.25 189-480v41h160v342Z" })
});
const OutlinedHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M349-97H189q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Zm-94-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z" })
});
const RoundedFilledHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M255-97h-66q-39 0-66.5-27.5T95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39-28 66.5T771-97h-65q-39.75 0-67.37-27.63Q611-152.25 611-191v-154q0-38.75 27.63-66.38Q666.25-439 706-439h65v-41q0-121.36-84.82-206.18Q601.36-771 480-771q-121.36 0-206.18 84.82Q189-601.36 189-480v41h66q38.75 0 66.38 27.62Q349-383.75 349-345v154q0 38.75-27.62 66.37Q293.75-97 255-97Z" })
});
const RoundedHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M255-97h-66q-39.05 0-66.53-27.47Q95-151.95 95-191v-289q0-80 30-150t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-480v289q0 39.05-27.77 66.53Q810.46-97 771-97h-65q-40.21 0-67.61-27.63Q611-152.25 611-191v-154q0-38.75 27.39-66.38Q665.79-439 706-439h65v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h66q38.75 0 66.38 27.62Q349-383.75 349-345v154q0 38.75-27.62 66.37Q293.75-97 255-97Zm0-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z" })
});
const SharpFilledHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M349-97H95v-382.62Q95-560 125-630t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-479.62V-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Z" })
});
const SharpHeadphones = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M349-97H95v-382.62Q95-560 125-630t82.5-122.5Q260-805 330-835.5T480-866q80 0 150 30.5t122.5 83Q805-700 835.5-630T866-479.62V-97H611v-342h160v-41q0-121.6-84.65-206.3Q601.69-771 480.17-771q-121.53 0-206.35 84.7T189-480v41h160v342Zm-94-248h-66v154h66v-154Zm451 0v154h65v-154h-65Zm-451 0h-66 66Zm451 0h65-65Z" })
});
const componentMap = {
	outlined: OutlinedHeadphones,
	"outlined-fill": OutlinedFilledHeadphones,
	rounded: RoundedHeadphones,
	"rounded-fill": RoundedFilledHeadphones,
	sharp: SharpHeadphones,
	"sharp-fill": SharpFilledHeadphones
};
const IconHeadphones = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconHeadphones };